import { INSURANCE_TYPES_NAMES } from 'constants/insurance-types-names';
import { prettifyNumber } from 'helpers';
import { createSelector } from 'reselect';
import { IAppState, IReferenceData } from 'types';

interface IFieldOptions {
  [key: string]: Array<{
    key: string;
    text: string;
    value: string | number;
  }>;
}

export const getClaimTypeOptions = (
  policyTypeName: string,
  referenceData: IReferenceData,
) => R.pathOr([], ['policyScan', policyTypeName, 'claimType'], referenceData);

const getExcessOptions = (
  policyType: string,
  referenceData: IReferenceData,
) => {
  const wiki = referenceData.wiki?.find(R.propEq('policyType', policyType));

  if (wiki?.excess) {
    return wiki.excess.map((k) => {
      const value = parseInt(k, 10);
      return {
        key: k,
        text: `$${prettifyNumber(value)}`,
        value,
      };
    });
  }

  if (policyType === INSURANCE_TYPES_NAMES.RV) {
    // RV has no wiki page setup, so hard code here,
    // TODO, if we have wiki page setup for RV, then we can remove this RV logic here
    return [
      {
        key: 500,
        text: `$500`,
        value: 500,
      },
      {
        key: 1000,
        text: `$1,000`,
        value: 1000,
      },
    ];
  }

  return [];
};

export const selectFieldOptions = (policyType: string) =>
  createSelector(
    (state: IAppState) => state.referenceData,
    (referenceData) => {
      const options = {} as IFieldOptions;

      if (
        policyType === INSURANCE_TYPES_NAMES.HOME_CONTENTS ||
        policyType === INSURANCE_TYPES_NAMES.LANDLORD
      ) {
        options.excessHome = getExcessOptions(
          INSURANCE_TYPES_NAMES.HOME,
          referenceData,
        );
        options.excessContents = getExcessOptions(
          INSURANCE_TYPES_NAMES.CONTENT,
          referenceData,
        );
      } else {
        options.excess = getExcessOptions(policyType, referenceData);
      }

      return options;
    },
  );
